import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Card } from 'react-bootstrap';
import InnerPageLayout from '../Components/Layout/InnerPageLayout';
import { useMsal } from '@azure/msal-react';
import LoginPage from './LoginPage';

function AttendancePage() {
  const { t, i18n } = useTranslation();
  const { instance, accounts } = useMsal();
  const [token, setToken] = useState<string | null>(null);
  const [msalInitialized, setMsalInitialized] = useState(false);

  useEffect(() => {
    const checkMsalInitialization = () => {
      if (instance && accounts && accounts.length > 0) {
        setMsalInitialized(true);
      }
    };

    checkMsalInitialization();
  }, [instance, accounts]);

  useEffect(() => {
    if (!msalInitialized) return;

    const fetchToken = async () => {
      try {
        const accessTokenRequest = {
          scopes: ['User.Read'],
          account: accounts[0],
        };

        const response = await instance.acquireTokenSilent(accessTokenRequest);
        if (response.accessToken) {
          console.log('Access token acquired:', response.accessToken);
          setToken(response.accessToken);
        } else {
          console.error('No access token found in response');
        }
      } catch (error) {
        console.error('Token acquisition failed', error);
      }
    };

    fetchToken();
  }, [msalInitialized, instance, accounts,i18n.language]);

  if (!msalInitialized) return  <LoginPage />;


  return (
    <InnerPageLayout>
      <Card className="mb-4">
        <Card.Header>{t('Attendance')}</Card.Header>
        <Card.Body>
          {token ? (
            <iframe
              src={`https://yellow-water-0cd9b5b03.4.azurestaticapps.net/#/home?lang=${i18n.language}&token=${token}`}
              style={{ width: '100%', height: '600px', border: 'none' }}
              title="Attendance"
            />
          ) : (
            <div>{t('loading')}</div>
          )}
        </Card.Body>
      </Card>
    </InnerPageLayout>
  );
}

export default AttendancePage;
